import {isInstanceOf} from 'rlink-type-utils';

 /**
  * This function defines what is considered a Collection
  * type.
  *
  * @param  {Collection}  obj
  * @return {Boolean}
  */
export default function isCollection (obj) {
  return (this.isIterable(obj)
    || isInstanceOf(obj, WeakMap)
    || isInstanceOf(obj, WeakSet));
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/isCollection.js